import React from 'react';
import Icon from './Icon';

const ExternalLinkIcon = (props) => (
    <Icon {...props}>
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 3h6v6M10 14L21 3" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default ExternalLinkIcon;